export const carouselItems = [
  {
    id: 1,
    title: '暑期档爆款合集',
    subtitle: '2026年最值得看的新片都在这里',
    description: '从国产大片到好莱坞巨制，暑期档强势片单每日更新，高清画质不缓冲，影迷的夏日观影指南。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20movie%20theater%20interior%20with%20golden%20lighting%2C%20film%20projector%20beam%20casting%20warm%20glow%2C%20red%20velvet%20seats%2C%20empty%20theater%2C%20atmospheric%20cinema%20aesthetic%2C%20rich%20amber%20tones%2C%20elegant%20composition%2C%20high%20detail%2C%20soft%20shadows&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '热门推荐',
  },
  {
    id: 2,
    title: '动作大片专区',
    subtitle: '肾上腺素飙升的视觉盛宴',
    description: '精选全球顶级动作电影，从经典港片到好莱坞巨制，高清画质流畅播放，让你足不出户体验影院级观影。',
    image: 'https://readdy.ai/api/search-image?query=Dramatic%20cinematic%20cityscape%20at%20twilight%20with%20warm%20golden%20and%20amber%20city%20lights%2C%20film%20grain%20texture%20overlay%2C%20cinematic%20color%20grading%2C%20atmospheric%20mood%2C%20modern%20skyline%2C%20movie%20poster%20aesthetic%2C%20rich%20contrast&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '动作冒险',
  },
  {
    id: 3,
    title: '经典重温系列',
    subtitle: '那些年我们追过的神作',
    description: '从《肖申克的救赎》到《霸王别姬》，经典永不褪色。蓝莓影院精选影史百大佳片，高清修复版免费在线观看。',
    image: 'https://readdy.ai/api/search-image?query=Vintage%20film%20reels%20and%20old%20movie%20posters%20on%20warm%20wooden%20table%2C%20soft%20golden%20hour%20light%20streaming%20through%20window%2C%20nostalgic%20cinema%20atmosphere%2C%20sepia%20and%20amber%20tones%2C%20classic%20movie%20memorabilia%2C%20elegant%20composition&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '经典佳片',
  },
  {
    id: 4,
    title: '华语新势力',
    subtitle: '国产电影崛起之路',
    description: '汇集最新华语电影佳作，从文艺片到商业大片，见证国产电影的蓬勃发展。每日更新，发现属于你的那部好片。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20Chinese%20cinema%20aesthetic%20with%20warm%20red%20and%20gold%20color%20palette%2C%20abstract%20film%20strip%20flowing%20across%20screen%2C%20contemporary%20art%20gallery%20style%2C%20soft%20dramatic%20lighting%2C%20cultural%20elements%2C%20cinematic%20composition&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '华语精选',
  },
  {
    id: 5,
    title: '动画奇幻世界',
    subtitle: '全家共享的欢乐时光',
    description: '从吉卜力到迪士尼，从国产动画新星到日本动漫经典，适合所有年龄段的动画电影大全，高清流畅不卡顿。',
    image: 'https://readdy.ai/api/search-image?query=Whimsical%20animation%20studio%20workspace%20with%20warm%20lighting%2C%20color%20pencils%20and%20storyboards%20on%20wooden%20desk%2C%20soft%20golden%20glow%2C%20creative%20atmosphere%2C%20film%20frames%20hanging%20on%20string%2C%20cozy%20artistic%20studio%2C%20rich%20warm%20tones&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '动画天地',
  },
];

export const comments = [
  {
    id: 1,
    name: '电影达人老王',
    avatar: 'https://readdy.ai/api/search-image?query=Middle%20aged%20Chinese%20man%20portrait%20with%20warm%20smile%2C%20casual%20style%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01&orientation=squarish',
    rating: 5,
    date: '2026-07-28',
    content: '用了蓝莓影院快两年了，片库真的很全。最近想重温《教父》三部曲，居然都有高清修复版，而且完全不卡顿，加载速度比我之前用的几个平台都快多了。',
  },
  {
    id: 2,
    name: '周末影迷小陈',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%20with%20bright%20smile%2C%20modern%20casual%20style%2C%20soft%20natural%20lighting%2C%20clean%20warm%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    rating: 5,
    date: '2026-07-25',
    content: '每个周末都会来蓝莓影院找片看，更新速度真的快！新上映的大片没几天就能看到高清版了，而且分类做得特别好，很容易找到自己喜欢的类型。',
  },
  {
    id: 3,
    name: '追剧不停的小李',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20man%20portrait%20with%20friendly%20expression%2C%20stylish%20glasses%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-03&orientation=squarish',
    rating: 4,
    date: '2026-07-22',
    content: '朋友推荐来的，一开始还担心画质不行，结果看了一部1080P的动作片直接爱上！不缓冲是真的不缓冲，我家50M宽带看高清毫无压力。希望片库能再多一些冷门文艺片。',
  },
  {
    id: 4,
    name: '电影系学生阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20student%20portrait%20with%20thoughtful%20expression%2C%20casual%20style%2C%20soft%20natural%20lighting%2C%20clean%20warm%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-04&orientation=squarish',
    rating: 5,
    date: '2026-07-20',
    content: '作为电影专业的学生，蓝莓影院的片源质量让我很惊喜。很多艺术片和独立电影都能找到，而且有中文字幕。每日更新的频率也很给力，已经推荐给全班同学了。',
  },
];

export const cards = [
  {
    id: 1,
    title: '科幻巨制专区',
    description: '从《星际穿越》到《沙丘》，探索无限宇宙的想象边界，高清画质带来沉浸式观影体验。',
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20abstract%20space%20scene%20with%20warm%20golden%20nebula%20and%20star%20clusters%2C%20cinematic%20composition%2C%20film%20grain%20texture%2C%20amber%20and%20deep%20red%20tones%2C%20sci-fi%20movie%20poster%20aesthetic%2C%20clean%20minimal%20design&width=600&height=400&seq=card-01&orientation=landscape',
    tag: '科幻',
  },
  {
    id: 2,
    title: '悬疑烧脑剧场',
    description: '精心挑选的悬疑推理影片，层层反转让你猜不到结局，每一帧都是线索。',
    image: 'https://readdy.ai/api/search-image?query=Mysterious%20foggy%20alley%20at%20night%20with%20warm%20street%20lamp%20glow%2C%20film%20noir%20aesthetic%2C%20dramatic%20shadows%2C%20amber%20light%20reflections%20on%20wet%20cobblestone%2C%20cinematic%20mood%2C%20rich%20contrast&width=600&height=400&seq=card-02&orientation=landscape',
    tag: '悬疑',
  },
  {
    id: 3,
    title: '喜剧欢乐时光',
    description: '精选国内外爆笑喜剧，无论是周末放松还是朋友聚会，总有一部让你笑出腹肌。',
    image: 'https://readdy.ai/api/search-image?query=Bright%20cheerful%20cinema%20lobby%20with%20warm%20golden%20lighting%2C%20colorful%20movie%20posters%20on%20walls%2C%20popcorn%20machine%2C%20vintage%20cinema%20decor%2C%20happy%20atmosphere%2C%20clean%20composition&width=600&height=400&seq=card-03&orientation=landscape',
    tag: '喜剧',
  },
  {
    id: 4,
    title: '恐怖惊悚夜',
    description: '胆量挑战者专区，从日式恐怖到欧美血浆，深夜独享的惊悚体验，你敢来吗？',
    image: 'https://readdy.ai/api/search-image?query=Atmospheric%20dark%20room%20with%20single%20warm%20candle%20light%2C%20old%20film%20projector%20casting%20amber%20glow%2C%20vintage%20horror%20movie%20posters%2C%20dust%20particles%20in%20light%20beam%2C%20cinematic%20horror%20aesthetic&width=600&height=400&seq=card-04&orientation=landscape',
    tag: '恐怖',
  },
  {
    id: 5,
    title: '纪录片探索',
    description: '精选BBC、国家地理及独立制作人的优质纪录片，打开你的知识新世界。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20library%20reading%20room%20with%20golden%20sunlight%20streaming%20through%20large%20windows%2C%20bookshelves%20and%20comfortable%20armchairs%2C%20vintage%20globe%2C%20documentary%20film%20aesthetic%2C%20intellectual%20atmosphere%2C%20rich%20amber%20tones&width=600&height=400&seq=card-05&orientation=landscape',
    tag: '纪录',
  },
];

export const indexItems = [
  { id: 1, title: '2026暑期档', count: 128, icon: 'ri-sun-line', color: 'accent' },
  { id: 2, title: '华语新片', count: 96, icon: 'ri-film-line', color: 'primary' },
  { id: 3, title: '好莱坞大片', count: 85, icon: 'ri-earth-line', color: 'secondary' },
  { id: 4, title: '日韩精选', count: 73, icon: 'ri-flag-line', color: 'accent' },
  { id: 5, title: '欧洲艺术片', count: 54, icon: 'ri-palette-line', color: 'primary' },
  { id: 6, title: '动画合集', count: 112, icon: 'ri-emotion-line', color: 'secondary' },
  { id: 7, title: '纪录片库', count: 67, icon: 'ri-camera-line', color: 'accent' },
  { id: 8, title: '经典重温', count: 201, icon: 'ri-vip-crown-line', color: 'primary' },
];

export const updates = [
  {
    id: 1,
    date: '2026-07-31',
    title: '今日更新 52 部影片',
    desc: '包括《流浪地球3》《封神第二部》等热门新片高清版已上线，另有15部经典电影修复版同步更新。',
    tag: '今日上新',
  },
  {
    id: 2,
    date: '2026-07-30',
    title: '暑期档特辑正式上线',
    desc: '精心策划的暑期档专题页面已发布，涵盖动作、喜剧、动画等多类型，一站式发现夏日好片。',
    tag: '专题上线',
  },
  {
    id: 3,
    date: '2026-07-28',
    title: '片库突破 20000 部',
    desc: '蓝莓影院累计收录影片正式突破两万部大关，覆盖全球60+个国家和地区的电影作品。',
    tag: '里程碑',
  },
  {
    id: 4,
    date: '2026-07-25',
    title: '播放体验全面升级',
    desc: 'CDN节点扩容完成，全国多地用户反馈播放速度明显提升，4K画质加载时间缩短40%。',
    tag: '系统升级',
  },
  {
    id: 5,
    date: '2026-07-22',
    title: '独立电影专区开放',
    desc: '全新开辟的独立电影专区收录了来自戛纳、柏林、威尼斯等国际电影节的获奖及入围作品。',
    tag: '新专区',
  },
  {
    id: 6,
    date: '2026-07-20',
    title: '手机端适配优化',
    desc: '针对移动端观影体验进行全面优化，支持横屏自动适配、手势控制亮度和音量。',
    tag: '功能优化',
  },
  {
    id: 7,
    date: '2026-07-18',
    title: '字幕语言扩充',
    desc: '新增日语、韩语、法语等多语种字幕支持，覆盖超过3000部外语影片。',
    tag: '内容扩充',
  },
  {
    id: 8,
    date: '2026-07-15',
    title: '用户推荐算法上线',
    desc: '基于观影历史的智能推荐系统正式启用，帮助影迷发现更多符合口味的好片。',
    tag: '新功能',
  },
];

export const features = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '极速加载不缓冲',
    description: '全球CDN加速节点覆盖，智能预加载技术确保观影过程零卡顿，即使是4K画质也能流畅播放，告别加载等待。',
  },
  {
    id: 2,
    icon: 'ri-movie-2-line',
    title: '海量片库每日更新',
    description: '片库超过20000部影片，覆盖全球60+国家和地区，每日新增50+部高清电影，片源更新速度行业领先。',
  },
  {
    id: 3,
    icon: 'ri-4k-line',
    title: '高清画质体验',
    description: '支持从720P到4K多种清晰度选择，自适应网络带宽智能切换，确保每位用户都能获得最佳观影画质。',
  },
  {
    id: 4,
    icon: 'ri-shield-check-line',
    title: '安全免费无广告',
    description: '完全免费观影，无弹窗广告干扰，无恶意软件捆绑，安全纯净的观影环境让你专注享受每一部好片。',
  },
  {
    id: 5,
    icon: 'ri-smartphone-line',
    title: '多端无缝观影',
    description: '支持电脑、平板、手机多端同步，观影记录云端保存，随时随地续看未看完的影片，观影不受限。',
  },
];

export const topics = [
  { id: 1, name: '暑期档', count: 128, hot: true },
  { id: 2, name: '科幻巨制', count: 96, hot: true },
  { id: 3, name: '悬疑推理', count: 84, hot: true },
  { id: 4, name: '国产新片', count: 76, hot: false },
  { id: 5, name: '动画电影', count: 112, hot: true },
  { id: 6, name: '动作冒险', count: 89, hot: false },
  { id: 7, name: '文艺片', count: 63, hot: false },
  { id: 8, name: '喜剧', count: 95, hot: false },
  { id: 9, name: '恐怖惊悚', count: 58, hot: false },
  { id: 10, name: '15分钟影评', count: 47, hot: false },
  { id: 11, name: '经典重温', count: 201, hot: true },
];

export const faqItems = [
  {
    id: 1,
    question: '蓝莓影院真的完全免费吗？',
    answer: '是的，蓝莓影院对所有用户完全免费。我们致力于为影迷提供高品质的免费观影体验，无需注册账号、无需付费会员，打开网站即可畅享海量高清电影资源。我们通过技术优化和合理的运营模式来维持平台运转，不会向用户收取任何费用。',
  },
  {
    id: 2,
    question: '为什么蓝莓影院播放不卡顿？',
    answer: '我们部署了全球CDN内容分发网络，在全国和海外多个节点提供就近加速服务。同时采用智能预加载和自适应码率技术，根据你的网络状况自动调整最佳画质，确保在不同网络环境下都能流畅播放。即使是1080P高清画质，正常家庭宽带也能无缓冲观看。',
  },
  {
    id: 3,
    question: '片库每天更新多少部电影？',
    answer: '蓝莓影院每日平均更新50部以上影片，包括最新上映的热门大片、经典老片高清修复版、独立电影以及纪录片等。我们的内容团队全天候跟踪全球电影动态，确保影迷能在第一时间看到想看的电影。遇到热门档期（如暑期档、贺岁档），更新量还会进一步增加。',
  },
  {
    id: 4,
    question: '支持哪些设备观看？',
    answer: '蓝莓影院全面支持PC电脑、Mac、iPad平板以及各类安卓和iOS手机。网页采用响应式设计，会自动适配不同屏幕尺寸。在移动端还支持横屏自动切换、手势调节亮度和音量等功能，让你随时随地享受影院级观影体验。',
  },
  {
    id: 5,
    question: '影片画质最高支持多少？',
    answer: '我们提供从流畅（480P）、标清（720P）、高清（1080P）到超清（4K）多种画质选择。大部分影片支持1080P高清，热门大片和经典修复版还提供4K超清版本。你可以在播放器中根据网络情况和设备性能自由切换画质。',
  },
  {
    id: 6,
    question: '如何找到我想看的电影？',
    answer: '你可以通过顶部的搜索功能直接搜索片名、导演或演员来查找影片。同时我们提供了按类型、地区、年份等多种分类浏览方式。首页还有"热门推荐""最新更新""经典重温"等多个专题入口。智能推荐系统会根据你的观影偏好，为你推送可能感兴趣的好片。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '暑期档必看TOP10',
    subtitle: '影评人精选 · 12分钟',
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20clapperboard%20on%20warm%20wooden%20surface%20with%20golden%20sunset%20light%2C%20vintage%20movie%20camera%20in%20background%2C%20soft%20bokeh%20effect%2C%20film%20production%20aesthetic%2C%20amber%20and%20gold%20tones&width=640&height=360&seq=media-01&orientation=landscape',
    duration: '12:30',
  },
  {
    id: 2,
    title: '经典港片修复对比',
    subtitle: '画质进化 · 8分钟',
    image: 'https://readdy.ai/api/search-image?query=Split%20screen%20vintage%20versus%20modern%20film%20frame%20comparison%2C%20warm%20cinematic%20lighting%2C%20old%20film%20grain%20texture%20beside%20clean%20digital%20image%2C%20amber%20and%20sepia%20tones&width=640&height=360&seq=media-02&orientation=landscape',
    duration: '08:15',
  },
  {
    id: 3,
    title: '独立电影幕后故事',
    subtitle: '导演访谈 · 15分钟',
    image: 'https://readdy.ai/api/search-image?query=Film%20director%20working%20on%20set%20in%20warm%20golden%20light%2C%20behind%20the%20scenes%20cinematography%2C%20camera%20crew%20in%20soft%20focus%2C%20cinematic%20production%20atmosphere%2C%20rich%20amber%20tones&width=640&height=360&seq=media-03&orientation=landscape',
    duration: '15:00',
  },
];

export const rankingItems = [
  { id: 1, rank: 1, title: '流浪地球3', type: '科幻', heat: '9.8', trend: 'up' },
  { id: 2, rank: 2, title: '封神第二部', type: '奇幻', heat: '9.6', trend: 'up' },
  { id: 3, rank: 3, title: '奥本海默', type: '传记', heat: '9.5', trend: 'stable' },
  { id: 4, rank: 4, title: '长安三万里', type: '动画', heat: '9.3', trend: 'up' },
  { id: 5, rank: 5, title: '碟中谍8', type: '动作', heat: '9.1', trend: 'down' },
  { id: 6, rank: 6, title: '孤注一掷2', type: '犯罪', heat: '8.9', trend: 'up' },
  { id: 7, rank: 7, title: '芭比', type: '喜剧', heat: '8.7', trend: 'stable' },
];